import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SectionHeading from "@/components/base/SectionHeading";

const GUIDES = [
  {
    icon: "ri-flag-2-line",
    titleKey: "helpCenter.guide1Title",
    descKey: "helpCenter.guide1Desc",
    tagKey: "helpCenter.guide1Tag",
    tone: "bg-primary-100 text-primary-700",
    to: "/apply",
  },
  {
    icon: "ri-lock-password-line",
    titleKey: "helpCenter.guide2Title",
    descKey: "helpCenter.guide2Desc",
    tagKey: "helpCenter.guide2Tag",
    tone: "bg-accent-100 text-accent-700",
    to: "/licenses",
  },
  {
    icon: "ri-swap-box-line",
    titleKey: "helpCenter.guide3Title",
    descKey: "helpCenter.guide3Desc",
    tagKey: "helpCenter.guide3Tag",
    tone: "bg-secondary-100 text-secondary-900",
    to: "/licenses",
  },
  {
    icon: "ri-calendar-schedule-line",
    titleKey: "helpCenter.guide4Title",
    descKey: "helpCenter.guide4Desc",
    tagKey: "helpCenter.guide4Tag",
    tone: "bg-primary-100 text-primary-700",
    to: "/licenses",
  },
  {
    icon: "ri-plug-2-line",
    titleKey: "helpCenter.guide5Title",
    descKey: "helpCenter.guide5Desc",
    tagKey: "helpCenter.guide5Tag",
    tone: "bg-accent-100 text-accent-700",
    to: "/docs/integration",
  },
  {
    icon: "ri-shield-keyhole-line",
    titleKey: "helpCenter.guide6Title",
    descKey: "helpCenter.guide6Desc",
    tagKey: "helpCenter.guide6Tag",
    tone: "bg-secondary-100 text-secondary-900",
    to: "/docs/integration",
  },
];

export default function GuideLibrary() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto w-full max-w-5xl px-4 py-14 md:px-6 md:py-16">
        <SectionHeading
          eyebrow={t("helpCenter.guidesEyebrow")}
          title={t("helpCenter.guidesTitle")}
          description={t("helpCenter.guidesDesc")}
        />

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {GUIDES.map((guide, index) => (
            <Link
              key={guide.titleKey}
              to={guide.to}
              className="lh-fade-up group flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="flex items-center justify-between">
                <span className={`flex h-11 w-11 items-center justify-center rounded-md ${guide.tone}`}>
                  <i className={`${guide.icon} text-xl`} />
                </span>
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
                  {t(guide.tagKey)}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {t(guide.titleKey)}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{t(guide.descKey)}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700">
                {t("helpCenter.guideOpen")}
                <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-0.5">
                  <i className="ri-arrow-right-line" />
                </span>
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-6 flex flex-col items-start justify-between gap-5 rounded-lg border border-background-200 bg-secondary-50 p-6 sm:flex-row sm:items-center">
          <div className="flex items-start gap-4">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-terminal-box-line text-2xl" />
            </span>
            <div>
              <h3 className="font-heading text-base font-semibold text-foreground-950">
                {t("helpCenter.docsTitle")}
              </h3>
              <p className="mt-1 max-w-xl text-sm leading-relaxed text-foreground-600">
                {t("helpCenter.docsDesc")}
              </p>
            </div>
          </div>
          <Link
            to="/docs/integration"
            className="inline-flex shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-book-2-line" />
            </span>
            {t("helpCenter.docsBtn")}
          </Link>
        </div>
      </div>
    </section>
  );
}